export default __webpack_public_path__ + "static/media/arcelik_marka_logo.bdc4e28d.png";